import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";



@Component({
  selector: 'app-statistics-subscription',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent extends BaseComponent implements OnInit {


  constructor(
  ) {
    super();



  }

  public isSelectedPage(nameId:any):boolean{
		if(!nameId){
			return false;
    }
		var namePageList = location.pathname;

		return namePageList==nameId;
	}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/statistics/statistics.component.ts